function getRectangleTopLeft(left: number, top: number, width: number, height: number, angle: number) {
  const originX = left + width / 2;
  const originY = top + height / 2;
  const radians = -angle * (Math.PI / 180);
  const cos = Math.cos(radians);
  const sin = Math.sin(radians);
  switch (angle) {
    case 90:
      left = left + width;
      break;
    case 180:
      left = left + width;
      top = top + height;
      break;
    case 270:
      top = top + height;
      break;
  }
  return {
    left: (left - originX) * cos - (top - originY) * sin + originX,
    top: (left - originX) * sin + (top - originY) * cos + originY
  };
}
export function getMousePos(event: {
  clientX: number;
  clientY: number;
}, stageBoundingRect: ClientRect | undefined | null, scale: number, rotation: number): [number, number] {
  let left = stageBoundingRect?.left ?? 0;
  let top = stageBoundingRect?.top ?? 0;
  const width = stageBoundingRect?.width ?? 0;
  const height = stageBoundingRect?.height ?? 0;
  let clientX = event.clientX;
  let clientY = event.clientY;
  if (rotation > 0 && rotation < 360) {
    const originX = left + width / 2;
    const originY = top + height / 2;
    const radians = -rotation * (Math.PI / 180);
    const cos = Math.cos(radians);
    const sin = Math.sin(radians);

    // https://danceswithcode.net/engineeringnotes/rotations_in_2d/rotations_in_2d.html
    // Use separate variables to avoid clientX mutation affecting the clientY formula
    const newClientX = (clientX - originX) * cos - (clientY - originY) * sin + originX;
    // Y axis is inverted in the browser, so the sign on the sin term is flipped
    const newClientY = (clientY - originY) * cos + (clientX - originX) * sin + originY;
    clientX = newClientX;
    clientY = newClientY;
    const {
      left: newLeft,
      top: newTop
    } = getRectangleTopLeft(left, top, width, height, rotation);
    left = newLeft;
    top = newTop;
  }
  return [(clientX - left) / scale, (clientY - top) / scale];
}